var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.height,"width":_vm.width,"viewBox":"0 0 50 100"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }